'use strict';

(function (angular) {
  angular.module('zp').directive('searchFiltersBar', searchFiltersBarDirective);

  /**@ngInject */
  function searchFiltersBarDirective($rootScope) {
    return {
      restirct: 'A',
      link: link,
      templateUrl: 'app/results/filters/search.filters.bar.html',
      scope: {
        filters: '=',
        onChange: '='
      }
    };

    function link(scope, element, attrs) {

      scope.searchModel = {};
      scope.filterResults = filterResults;

      scope.doFilter = doFilter;
      scope.resetTextSearch = resetTextSearch;

      var firstRun = true;
      var filtersChanged = false;

      (function () {
        scope.$watch('searchModel', function () {
          filterResults();
        }, true);
        for (var i = 0; i < scope.filters.length; i++) {
          if (scope.filters[i].defaultValue) {
            scope.searchModel[scope.filters[i].alias] = scope.filters[i].defaultValue;
            scope.searchModel[scope.filters[i].alias + '_label'] = scope.filters[i].defaultLabel;
          }
        }
        $rootScope.$on('filters:reset', function (event, data) {
          scope.searchModel[data.alias] = null;
        });
      })();

      ////////////////////////////////////////////

      function filterResults() {
        if (firstRun) {
          firstRun = false;
          return;
        }
        for (var i in scope.searchModel) {
          if (!scope.searchModel.hasOwnProperty(i)) {
            continue;
          }
          var filter = scope.filters.find(function (f) {
            return f.alias === i;
          });
          if (filter) {
            filtersChanged = true;
            if (filter.control === 'dropdown') {
              filter.selectedIndex = parseFloat(scope.searchModel[i]);
              filter.selectedValue = filter.values[filter.selectedIndex];
            } else {
              filter.selectedValue = scope.searchModel[i];
            }
          }
        }
        $rootScope.$broadcast('filters:changed', scope.filters);
      }

      function doFilter() {
        if (filtersChanged) {
          scope.filterInProgress = true;
          if (scope.onChange) {
            scope.onChange(scope.filters);
          }
          scope.filterInProgress = false;
        }
      }

      function resetTextSearch(alias) {
        scope.searchModel[alias] = '';
      }
    }
  }
})(window.angular);